// extracted by mini-css-extract-plugin
module.exports = {"filters":"fuel-history_filters__AaLWG","table":"fuel-history_table__1LUKu","avatar":"fuel-history_avatar__FNdJz"};